import { useState, useEffect, useCallback } from 'react';
import { kvGet, kvPut } from '../services/cloudStorage';

const ARCHIVE_DAYS = 30;

function cutoffISO() {
  const d = new Date();
  d.setDate(d.getDate() - ARCHIVE_DAYS);
  return d.toISOString();
}

export function useGroupChat(user) {
  const [messages, setMessages] = useState([]);
  const [archive,  setArchive]  = useState([]);
  const [loading,  setLoading]  = useState(true);

  const fetchMessages = useCallback(async () => {
    const all = (await kvGet('group:group_chat')) || [];
    const cutoff = cutoffISO();
    const active = all.filter(m => m.createdAt >= cutoff);
    const old    = all.filter(m => m.createdAt <  cutoff);
    if (old.length > 0) {
      const existing = (await kvGet('group:group_chat_archive')) || [];
      await kvPut('group:group_chat_archive', [...existing, ...old]);
      await kvPut('group:group_chat', active);
    }
    setMessages(active.slice().sort((a, b) => a.createdAt.localeCompare(b.createdAt)));
    setLoading(false);
  }, []);

  const sendMessage = useCallback(async (text) => {
    if (!text.trim() || !user) return;
    const msg = {
      id:        `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
      userId:    user.id,
      username:  user.username,
      text:      text.trim(),
      createdAt: new Date().toISOString(),
    };
    const updated = [...messages, msg];
    setMessages(updated);
    await kvPut('group:group_chat', updated);
  }, [messages, user]);

  const loadArchive = useCallback(async () => {
    const data = (await kvGet('group:group_chat_archive')) || [];
    setArchive(data.slice().sort((a, b) => a.createdAt.localeCompare(b.createdAt)));
  }, []);

  const exportBackup = useCallback(() => {
    const all = [...archive, ...messages]
      .slice()
      .sort((a, b) => a.createdAt.localeCompare(b.createdAt));
    const lines = all.map(m => {
      const d = new Date(m.createdAt).toLocaleString('it-IT');
      return `[${d}] ${m.username}: ${m.text}`;
    }).join('\n');
    const blob = new Blob([lines], { type: 'text/plain;charset=utf-8' });
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement('a');
    a.href     = url;
    a.download = `group_chat_${new Date().toISOString().slice(0, 10)}.txt`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }, [messages, archive]);

  useEffect(() => {
    fetchMessages();
    const iv = setInterval(fetchMessages, 15000);
    return () => clearInterval(iv);
  }, [fetchMessages]);

  return { messages, archive, loading, sendMessage, loadArchive, exportBackup };
}
